import React, { useState, useEffect, useRef } from "react";
import { FiPhone } from "react-icons/fi";
import { MdPassword } from "react-icons/md";
import { MdOutlineLockOpen } from "react-icons/md";
import { MdLockOutline } from "react-icons/md";
import { useNavigate } from 'react-router-dom';

import urls from "../../Utils/urls";

export default function Login() {
    const navigate = useNavigate();
    const [phoneDigits, setPhoneDigits] = useState(Array(10).fill(""));
    const [password, setPassword] = useState("");
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [otpStep, setOtpStep] = useState(false);
    const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
    const [timer, setTimer] = useState(30);
    const [resendVisible, setResendVisible] = useState(false);
    const [userId, setUserId] = useState(null);
    const [loading, setLoadding] = useState(false)

    const phoneRefs = useRef([]);
    const otpRefs = useRef([]);


    useEffect(() => {
        let countdown;
        if (otpStep && timer > 0) {
            countdown = setInterval(() => setTimer((prev) => prev - 1), 1000);
        } else if (timer === 0) {
            setResendVisible(true);
        }
        return () => clearInterval(countdown);
    }, [otpStep, timer]);

    const handlePhoneChange = (value, index) => {
        if (/^\d?$/.test(value)) {
            const newDigits = [...phoneDigits];
            newDigits[index] = value;
            setPhoneDigits(newDigits);
            if (value && index < 9) {
                phoneRefs.current[index + 1].focus();
            }
        }
    };

    const handlePhoneKeyDown = (e, index) => {
        if (e.key === "Backspace" && !phoneDigits[index] && index > 0) {
            phoneRefs.current[index - 1].focus();
        }
    };

    const handleOtpChange = (value, index) => {
        if (/^\d?$/.test(value)) {
            const newOtp = [...otpDigits];
            newOtp[index] = value;
            setOtpDigits(newOtp);
            if (value && index < 5) {
                otpRefs.current[index + 1].focus();
            }
        }
    };

    const handleOtpKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
            otpRefs.current[index - 1].focus();
        }
    };

    const handleSendOtp = async () => {
        const phoneNo = phoneDigits.join("");
        if (termsAccepted && phoneDigits.every((d) => d !== "") && password) {
            try {
                setLoadding(true)
                const res = await fetch(`${urls.API_BASEPATH}/user/login`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ identifier: phoneNo, password }),
                });
                const data = await res.json()
                if (data.status === 1) {
                    setUserId(data.user_id)
                    setOtpStep(true);
                    setTimer(30);
                    setResendVisible(false);
                    otpRefs.current[0]?.focus();
                } else {
                    alert(data.message || "Login failed");
                }

            } catch (err) {
                console.error("Error:", err);
            } finally {
                setLoadding(false)
            }

        }
    };

    const handleResendOtp = async () => {
        const phoneNo = phoneDigits.join("");
        try {
            const res = await fetch(`${urls.API_BASEPATH}/user/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ identifier: phoneNo, password }),
            });
            const data = await res.json()
            if (data.status === 1) {
                setUserId(data.user_id)
                setOtpStep(true);
                setTimer(30);
                setResendVisible(false);
                otpRefs.current[0]?.focus();
            } else {
                alert(data.message || "Login failed");
            }

        } catch (err) {
            console.error("Error:", err);
        }

        setTimer(30);
        setResendVisible(false);
        setOtpDigits(Array(6).fill(""));
        otpRefs.current[0]?.focus();
    };

    const handleVerifyOtp = async () => {
        const otp = otpDigits.join("");
        try {
            setLoadding(true)
            const res = await fetch(`${urls.API_BASEPATH}/user/verify_otp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ user_id: userId, otp }),
            })
            const data = await res.json();
            if (data.status === 1) {
                localStorage.setItem("access_token", data.tokens.access_token);
                localStorage.setItem("refresh_token", data.tokens.refresh_token);
                localStorage.setItem("expires_in", data.tokens.expires_in);
                alert(data.message);
                navigate('/admin/reports-details')
            }
            else {
                alert(data.message || "Invalid OTP");
            }
        } catch (err) {
            console.error('Error: ', err);
        }
        finally {
            setLoadding(false)
        }

    };

    return (
        <div className="flex justify-center min-h-screen bg-gradient-to-br from-[#4FA0FF]/10 via-[#FFFFFF] to-[#FFD700]/10">
            <div className="flex-1 flex items-center justify-center">
                <div className="bg-white shadow-2xl rounded-3xl px-6 py-10 md:p-10 w-full max-w-lg border border-[#E5E5E5] transition-transform transform">

                    {/* --- FORM 1: PHONE + PASSWORD --- */}
                    {!otpStep && (
                        <form className="space-y-6">
                            <div className="flex gap-4 items-center mb-6">
                                <div className="flex items-center justify-center w-14 h-14 rounded-full bg-[#4FA0FF] text-white text-xl">
                                    <FiPhone />
                                </div>
                                <div>
                                    <h2 className="text-3xl font-bold text-[#1D3557] tracking-tight">
                                        Verify Your Phone
                                    </h2>
                                    <p className="text-md text-gray-600">Enter your phone number to get started</p>
                                </div>
                            </div>

                            <span className="font-medium text-md text-[#1D3557]">Enter your Phone no. </span>
                            {/* Phone number inputs */}
                            <div className="flex justify-center gap-2">
                                {phoneDigits.map((digit, i) => (
                                    <input
                                        key={i}
                                        ref={(el) => (phoneRefs.current[i] = el)}
                                        type="text"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => handlePhoneChange(e.target.value, i)}
                                        onKeyDown={(e) => handlePhoneKeyDown(e, i)}
                                        className="max-w-[40px] w-full h-14 border border-[#E5E5E5] rounded-xl text-center text-lg font-semibold shadow-sm focus:ring-2 focus:ring-[#4FA0FF] focus:border-[#4FA0FF] outline-none transition"
                                    />
                                ))}
                            </div>

                            {/* Password Field */}
                            <div className="flex items-center justify-center border border-[#E5E5E5] py-2 px-2 rounded-xl shadow-sm focus:ring-2 focus:ring-[#4FA0FF] transition">
                                <MdOutlineLockOpen className="text-gray-400 text-xl" />
                                <input
                                    type="password"
                                    placeholder="Enter Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full outline-none border-0 focus:ring-0"
                                />
                            </div>

                            {/* Terms & Conditions */}
                            <div className="flex items-center space-x-3">
                                <input
                                    type="checkbox"
                                    checked={termsAccepted}
                                    onChange={(e) => setTermsAccepted(e.target.checked)}
                                    className="w-5 h-5 text-[#4FA0FF] border-gray-300 rounded focus:ring-[#4FA0FF]"
                                />
                                <label className="text-sm text-gray-600 select-none">
                                    I agree to the{" "}
                                    <span className="text-[#4FA0FF] font-medium cursor-pointer hover:underline">
                                        Terms & Conditions
                                    </span>
                                </label>
                            </div>

                            {/* Send OTP button */}

                            <button
                                type="button"
                                onClick={handleSendOtp}
                                disabled={!(termsAccepted && phoneDigits.every((d) => d !== "") && password)}
                                className={`w-full py-3 rounded-xl font-semibold shadow-md transition transform active:scale-95 border-0 ${termsAccepted && phoneDigits.every((d) => d !== "") && password
                                    ? "!bg-[#FFD700] text-[#1D3557] hover:!bg-[#FFE55C] hover:!text-[#1D3557]"
                                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                                    }`}
                            >
                                {loading ? (
                                    <div className="flex items-center gap-2 justify-center">
                                        <svg
                                            className="animate-spin h-5 w-5 text-[#1D3557]"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                        >
                                            {/* Simplified path - faster rendering */}
                                            <path
                                                fill="currentColor"
                                                d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                                                opacity="0.25"
                                            />
                                            <path
                                                fill="currentColor"
                                                d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
                                            />
                                        </svg>
                                        Sending OTP...
                                    </div>
                                ) : (
                                    "Send OTP"
                                )}
                            </button>
                        </form>
                    )}

                    {/* --- FORM 2: OTP VERIFICATION --- */}
                    {otpStep && (
                        <form className="space-y-6">
                            <div className="flex gap-4 items-center mb-8">
                                <div className="flex items-center justify-center w-14 h-14 rounded-full bg-[#4FA0FF] text-white text-xl">
                                    <MdLockOutline />
                                </div>
                                <div>
                                    <h2 className="text-3xl font-bold text-[#1D3557] tracking-tight">
                                        Enter Verification Code
                                    </h2>
                                    <p className="text-md text-gray-600">Code sent to +91{phoneDigits.join("")} </p>
                                </div>
                            </div>

                            {/* OTP Inputs */}
                            <span className="font-medium text-md text-[#1D3557]">Enter 6-digit code</span>
                            <div className="flex justify-center gap-3">
                                {otpDigits.map((digit, i) => (
                                    <input
                                        key={i}
                                        ref={(el) => (otpRefs.current[i] = el)}
                                        type="text"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => handleOtpChange(e.target.value, i)}
                                        onKeyDown={(e) => handleOtpKeyDown(e, i)}
                                        className="max-w-[50px] w-full h-14 border border-[#E5E5E5] rounded-xl text-center text-xl font-semibold shadow-sm focus:ring-2 focus:ring-[#4FA0FF] focus:border-[#4FA0FF] outline-none transition"
                                    />
                                ))}
                            </div>

                            {/* Verify OTP button */}
                            <button
                                type="button"
                                onClick={handleVerifyOtp}
                                className="w-full bg-[#FFD700] text-[#1D3557] py-3 rounded-xl font-semibold shadow-md hover:!bg-[#FFE55C] hover:!text-[#1D3557] transition transform active:scale-95"
                            >
                                {loading ? (
                                    <div className="flex items-center gap-2 justify-center">
                                        <svg
                                            className="animate-spin h-5 w-5 text-[#1D3557]"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                        >
                                            {/* Simplified path - faster rendering */}
                                            <path
                                                fill="currentColor"
                                                d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                                                opacity="0.25"
                                            />
                                            <path
                                                fill="currentColor"
                                                d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
                                            />
                                        </svg>
                                        Verifying OTP...
                                    </div>
                                ) : (
                                    "Verify OTP"
                                )}
                            </button>

                            {/* Timer / Resend */}
                            <div className="text-center">
                                {!resendVisible ? (
                                    <p className="text-sm text-gray-500">
                                        Resend OTP in{" "}
                                        <span className="font-medium text-[#1D3557]">{timer}s</span>
                                    </p>
                                ) : (
                                    <button
                                        type="button"
                                        onClick={handleResendOtp}
                                        className="bg-transparent rounded-2xl px-5 py-2 text-[#4FA0FF] font-medium hover:underline"
                                    >
                                        Resend OTP
                                    </button>
                                )}
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}